import React from 'react';
import styled, { keyframes } from 'styled-components';
import { LoadingContainer, LoadingContent } from './loading.style';
import { IntlMessages } from '../../helper/langHelper';
import { LocationIcon } from '../../icons';

// Animations
const float = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-15px);
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.05);
  }
`;

const ripple = keyframes`
  0% {
    transform: scale(0.8);
    opacity: 0.6;
  }
  100% {
    transform: scale(1.4);
    opacity: 0;
  }
`;

// Styled Components
const IconContainer = styled.div`
  position: relative;
  width: 180px;
  height: 180px;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PlatformCircle = styled.div`
  position: absolute;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(139, 92, 246, 0.15) 100%);
  box-shadow: 0 8px 32px rgba(99, 102, 241, 0.25);
  animation: ${pulse} 2.5s ease-in-out infinite;
`;

const RippleEffect = styled.div`
  position: absolute;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  border: 2px solid rgba(99, 102, 241, 0.3);
  animation: ${ripple} 2.5s ease-out infinite;
  animation-delay: ${(props) => props.delay || '0s'};
`;

const LocationPinWrapper = styled.div`
  position: relative;
  z-index: 2;
  animation: ${float} 3s ease-in-out infinite;
  filter: drop-shadow(0 8px 16px rgba(99, 102, 241, 0.3));
`;

const StyledLoadingText = styled.p`
  margin-top: 1rem;
  font-size: 1rem;
  color: #4b5563;
`;

const LoadingScreenSecondary = ({ message = <IntlMessages id="map.processing.message" /> }) => {
  return (
    <LoadingContainer role="alert" aria-live="assertive">
      <LoadingContent>
        <IconContainer>
          <RippleEffect delay="0s" />
          <RippleEffect delay="0.7s" />
          <RippleEffect delay="1.4s" />
          <PlatformCircle />
          <LocationPinWrapper>
            <LocationIcon />
          </LocationPinWrapper>
        </IconContainer>
        <StyledLoadingText>{message}</StyledLoadingText>
      </LoadingContent>
    </LoadingContainer>
  );
};

export default LoadingScreenSecondary;
